import { CardUIExtension, ICardUIExtensionContext, ICardModel } from 'tessa/ui/cards';
import { Guid, createTypedField, DotNetType } from 'tessa/platform';
import { CdUIHelper } from '../CdUIHelper';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { Card } from 'tessa/cards';
import { CdExecutiveDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdExecutiveDocumentationClientHelper';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';

export class CdExecutiveDocumentationUIExtension extends CardUIExtension {

  private _disposer: Function | null = null;

  public async initialized(context: ICardUIExtensionContext) {
    let model: ICardModel;
    let card: Card;
    if ((model = context.model) == null ||
        (card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkExecutiveDocumentationTypeID)) {
    return;
    }
    // Таблица "Объект"
    CdUIHelper.InitializeTableObjects(context);
    CdGeneralDocumentationClientHelper.MatchingVisabilityLogic(context);
    CdExecutiveDocumentationClientHelper.FieldLogic(card, model);
    CdExecutiveDocumentationClientHelper.FillApproversLogic(context);
    CdExecutiveDocumentationClientHelper.ButtonLogic(card, model);
    CdExecutiveDocumentationClientHelper.FillLegalEntity(model);
    CdExecutiveDocumentationClientHelper.TableOrderLogic(card, context);    
    CdExecutiveDocumentationClientHelper.FieldsTemplateLogic(card, model);
    CdExecutiveDocumentationClientHelper.FieldsExecutiveSchemeTable(card);
    CdExecutiveDocumentationClientHelper.FieldsHiddenWorksLogic(card, model,context);
    CdExecutiveDocumentationClientHelper.ExecutiveSchemeForEdControlLogic(card, model, context);
    CdExecutiveDocumentationClientHelper.FillSpecialistNumber(card);
    CdExecutiveDocumentationClientHelper.ItdBlockLogic(context);
  }

  public async saving(context: ICardUIExtensionContext) {
    let card: Card;
    if ((card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkExecutiveDocumentationTypeID)) {
      return;
    }

    let ediSection = card.sections.tryGet("PkExecutiveDocumentationInfo");
    if (ediSection &&
        ediSection.fields.has('EDKindNewID') &&
        !ediSection.fields.tryGet('EDKindNewID')) {
      ediSection.fields.rawSet('EDKindNewID', createTypedField('00000000-0000-0000-0000-000000000000', DotNetType.Guid));
    }
    
    await CdExecutiveDocumentationClientHelper.CheckAddedFiles(context, 0);
    if (await !CdGeneralDocumentationClientHelper.CheckEditSignedFile(card)) {
      context.cancel = true;
    }
  }

  public finalized() {
    // подчищаем за собой
    if (this._disposer) {
        this._disposer();
        this._disposer = null;
    }
  }
}